<!-- STRAT TESTIMONIAL -->
<section class="section bg-client" id="testi">
    <div class="container">
        <div class="row justify-content-center mt-5 mb-5">
            <div class="col-lg-12">
                <div class="text-center" style="padding-bottom:3%">
                    <p class="fontt text-muted home-subtitle-center mx-auto home-subtitle mt-4 mb-0"
                        style="font-size: 45px; color: white !important;">C<strong
                            style="font-family: 'Montserrat-Regular', sans-serif;color: white;">RONOLOGÍA </strong></p>      
                </div>
                
                <owl-carousel-o [options]="customOptions">
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2004</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
Al iniciar el semestre marzo 2004, los profesores, con el liderazgo del Lic. Ángel Loor Giler, como decano de la Facultad, en ese entonces llamada ya, Comunicación, surgió la idea de organizar la Exposición a nivel de la facultad, pero abierta a la Universidad y colectividad. La idea tuvo respaldo inmediato de las autoridades, docentes y estudiantes.<br/>
Los estudiantes de la Facultad de Comunicación, que incluía las carreras de Diseño Gráfico y Periodismo se fusionaron armónicamente para mostrar todo el potencial profesional. En la noche del jueves 19 de agosto todo quedó listo para ejecutar oficialmente la Primera Expocomunicarte. Se desarrolló en el salón de actos de la Universidad, ubicado en la calle Sucre y García Moreno.
</p>
                                
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2005</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
                             Los resultados del evento fueron positivos y vino la segunda exposición, que se desarrolló los días 9 y 10 de marzo del 2005, en el salón de eventos del hotel ejecutivo. El proyecto comenzaba así a tomar más fuerza.<br/>
La siguiente feria se desarrolló el 9 de diciembre de 2005, en el parque Vicente Amador Flor. Allí llegaron autoridades y personalidades reconocidas en la política, el arte y la cultura de la provincia. En este evento se publicaron interesantes entrevistas, novedosos diseños, noticias, crónicas, reportajes, dibujos, fotografías y diseños.<br />
Ese año la Facultad de Comunicación decidió que la Expocomunicarte se la organice los primeros días de diciembre, en homenaje al mes en que la Universidad celebra su aniversario de creación. 
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2006 - 2007</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
                             La Expocomunicarte 2006 se desarrolló el 8 de diciembre, en el parque Eloy Alfaro. Por primera vez se contó con la participación de otras carreras, la visita fue masiva.<br/>
En el 2007, la Expocomunicarte se desarrolló en la Casa de la Cultura de Manabí, participaron la mayoría de las carreras de la Universidad, y estuvieron presentes, con sus trabajos, los estudiantes de la extensión universitaria en Chone. 
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2008</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
En el 2008, cuando la Universidad inauguró su nuevo edificio, y reunió a todas las carreras en su campus, el Consejo Universitario resolvió institucionalizar la Expocomunicarte como el evento que diera apertura a las festividades de su aniversario de creación. En este año se realizó el evento dentro de los predios de la Universidad por primera vez.

                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2009 - 2010</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
En 2009, las carreras ofrecieron nuevos empleos que reflejaron el talento de los jóvenes estudiantes en diversas ciencias. La Expocomunicarte creció significativamente y se hizo reconocida dentro y fuera de la Universidad. La Carrera de Ciencias de la Comunicación, dirigida por la Lcda. Mirelly Zambrano Alcívar, formó un comité organizador con personas como el Lcdo. Ángel Loor Giler y el Lcdo. Jorge Zambrano. El comité, presidido por el Arquitecto Jaime Alarcón, logró el éxito en la Expocomunicarte de 2009 y continuó su labor en 2010 con la participación de las coordinadoras académicas de la Universidad.
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2011 - 2013</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">

En el 2011 y 2012 la feria se desarrolló con total éxito en el Campus Universitario y el Comité lo siguió presidiendo el Arquitecto Jaime Alarcón, con la participación de todas las carreras de la Universidad y la visita masiva de estudiantes de bachillerato de las instituciones educativas. Durante el 2013 y 2014 la feria tomaba más fuerza, convirtiéndose en el evento favorito de los gregorianos estos años fueron una autentica confraternidad universitaria y de vinculación con la sociedad.

                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2014</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">

En el 2014 se firmó dentro del marco de la Expocomunicarte un convenio con la Secretaría Técnica Inclusiva en Discapacidades (SETEDIS) que permitió establecer nexos de colaboración y acción conjunta entre ambas entidades, que permitió promover la inclusión de las personas con discapacidad y sus familias.
Desde esta edición se realizó el concurso “Voces Gregorianas”, que cada año premia a los artistas de la universidad. 
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2015 - 2016</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
En los años 2015 y 2016 las calidades de los proyectos presentados aumentaban su nivel, con gran entrega y compromiso de los integrantes del alma mater.<br/>
En el 2016 un año difícil para Manabí y Portoviejo, la Expocomunicarte se convirtió en ese espacio de recreación, también de recuerdos y añoranzas de los momentos más tristes que dejó el terremoto del 16 de abril.

                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2017 - 2018</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
Durante el 2017 y 2018, esta feria se desarrsolló con la visita masiva de personas durante todo el día en los predios de la universidad, con exposiciones y a actividades de última gama, concursos y premios que cada vez atraían a más visitantes.
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2019</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
En el 2019, la Expocomunicarte fue el momento escogido para inaugurar el parqueadero #3 y cada una de las adecuaciones en infraestructura de la universidad, además de presentar las actividades y stands con temáticas que realizaron los gregorianos de cada área sustancial de la institución.<br/>
Recibiendo también la visita de los delegados del Consejo de Aseguramiento de la Calidad de la Educación Superior CACES, quienes se encontraban evaluando a la universidad para su posterior acreditación.                                 </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2020</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
                                    
En el 2020, un año que reinventó la educación, la Expocomunicarte no ha detenido sus pasos a pesar de la pandemia del coronavirus, la Universidad San Gregorio de Portoviejo apostó por la digitalización.<br/>
La Expocomunicarte presento para esta edición un recorrido multimedia de alta tecnología y abrió sus puertas virtuales para el público nacional e internacional, haciendo que la feria académica más importante de la provincia de Manabí, no tenga fronteras.

                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2021</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
                                    
Este 2021 la Expocomunicarte continúa creciendo y adaptándose a los cambios provocados por la pandemia de la Covid 19 y continúa en la modalidad virtual con eventos hibridos y presenciales, la Universidad San Gregorio de Portoviejo continúa apostando por la digitalización.<br/>
La Expocomunicarte presenta para esta edición un recorrido multimedia de alta tecnología y abrió sus puertas virtuales para el público nacional e internacional, haciendo que la feria académica más importante de la provincia de Manabí, no tenga fronteras. Asi mismo retoma los eventos híbridos y presenciales. 
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2022</i>
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
                                    
la Expocomunicarte del 2022, apostó por eventos híbridos y presenciales. Teniendo como objetivo la exposición de los conocimientos y los trabajos que hacen los estudiantes durante su proceso de estudios.<br/>
La Universidad San Gregorio de Portoviejo hace una cordial invitación a este importante evento que es una vitrina de orientación para los bachilleres de Manabí.<br />
Quienes llegan a presenciar cada una de las ciencias que ofrece el Alma Mater y los ayuda a escoger su futura profesión. 
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="text-center w-75 mx-auto">
                            <div class="testi-icon text-white">
                                <i class="">2023</i> 
                            </div>
                            <div class="mt-3">
                                <p class="testi-user-name text-center text-white mb-0 mt-4">
La Expo Comunicarte 2023, que se llevará a cabo los días 29, 30 de noviembre y 01 de diciembre, será un fascinante
encuentro que fusionará la ciencia y el futuro, prometiendo una experiencia única que inspirará y desafiará nuestra percepción del mundo. Un espacio imperdible donde la ciencia se entrelaza con la imaginación, trazando el camino hacia un futuro más conectado e innovador.
                                </p>
                    
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!-- END TESTIMONIAL -->